<template>
  <div class="desp">
    <div class="desp-header">Confirmation:</div>
    <div class="desp-items-group">
      <div class="desp-items-group-title-icon">
        <svg-icon name="applicant" class="jump-icon"></svg-icon>
        Applicant information
      </div>
      <div class="desp-items-wrapper">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Applicant Name</div>
              <div class="desp-item-content">{{ detail.applicantName }}</div>
            </div>
          </el-col>
          <template v-if="detail.companyApplyment">
            <el-col :span="8">
              <div class="desp-item">
                <div class="desp-item-label">Mobile</div>
                <div class="desp-item-content">{{ detail.companyApplyment.applicantPhone }}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="desp-item">
                <div class="desp-item-label">Email</div>
                <div class="desp-item-content">{{ detail.companyApplyment.applicantEmail }}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="desp-item">
                <div class="desp-item-label">Residential Address</div>
                <div class="desp-item-content">{{ detail.companyApplyment.residentialAddress }}</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="desp-item">
                <div class="desp-item-label">Applicant role</div>
                <div class="desp-item-content">
                  {{ applicantPositionFormat(detail.companyApplyment.applicantPosition) }}
                </div>
              </div>
            </el-col>
          </template>
        </el-row>
      </div>
    </div>
    <div class="desp-items-group" v-if="detail.companyApplyment">
      <div class="desp-items-group-title-icon">
        <svg-icon name="country" class="jump-icon"></svg-icon>
        Location of the proposed company
      </div>
      <div class="desp-item">
        <div class="desp-item-self">{{ detail.companyApplyment.country }}</div>
      </div>
    </div>

    <!-- 套餐、自定义套餐、Quotation定制化服务 -->
    <div class="desp-items-group" v-if="detail.orderType == 'generic' || detail.orderType == 'quotation_part'">
      <div class="desp-items-group-title-icon">
        <svg-icon name="planAndServices" class="jump-icon"></svg-icon>
        Choice of service(s)
      </div>
      <div class="desp-item">
        <div class="desp-item-self">
          <div class="mt10">
            <template v-if="detail.orderType == 'generic'">
              <!-- 套餐 -->
              <template v-if="detail?.companyApplyment?.goodsListType == 1">
                <Package :goodsList="detail.goodsList" />
              </template>
              <!-- 自定义套餐 -->
              <template v-if="detail?.companyApplyment?.goodsListType == 2">
                <diy-package :businessType="detail.businessType" :goodsList="detail.goodsList" />
              </template>
            </template>
            <template v-if="detail.orderType == 'quotation_part'">
              <!-- Quotation定制化服务-小计 -->
              <quotation-subtotal :businessType="detail.businessType" :quotationPart="detail.quotationPart" :billingCurrency="detail.billingCurrency" />
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- Quotation (V) -->
    <div class="desp-items-group" v-if="detail.orderType == 'adjustment'">
      <div class="desp-items-group-title">Quotation (V)</div>
      <div class="desp-item">
        <div class="desp-item-self">
          <div class="mt10">
            <!-- Quotation(V)小额补款 - 单项 -->
            <quotation-v-single :detail="detail" />
          </div>
        </div>
      </div>
    </div>

    <!-- 订单 -->
    <div class="desp-items-group">
      <div class="desp-items-group-title">Order</div>
      <div class="desp-items-wrapper">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Transaction No.</div>
              <div class="desp-item-content">{{ detail.businessNo }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Order No.</div>
              <div class="desp-item-content">{{ detail.orderNo }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Create Time</div>
              <div class="desp-item-content">{{ detail.createTime }}</div>
            </div>
          </el-col>

          <template v-if="detail.companyApplyment">
            <el-col :span="8">
              <div class="desp-item">
                <div class="desp-item-label">Coordinator</div>
                <div class="desp-item-content">
                  {{ detail.companyApplyment?.coordinator?.nickname || "" }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="desp-item">
                <div class="desp-item-label">Checker</div>
                <div class="desp-item-content">
                  {{ detail.companyApplyment?.checker?.nickname || "" }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="desp-item">
                <div class="desp-item-label">Reviewer</div>
                <div class="desp-item-content">
                  {{ detail.companyApplyment?.auditor?.nickname || "" }}
                </div>
              </div>
            </el-col>
          </template>

          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Pay Type</div>
              <div class="desp-item-content">{{ payTypesFormat(detail.payType) }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Transfer Remark</div>
              <div class="desp-item-content">{{ detail.transferVerifyRemark }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 供应商 -->
    <div class="desp-items-group" v-if="detail.supplier">
      <div class="desp-items-group-title">Supplier</div>
      <div class="desp-items-wrapper">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Abbreviation</div>
              <div class="desp-item-content">{{ detail.supplier?.abbr || "" }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Company Name</div>
              <div class="desp-item-content">{{ detail.supplier?.companyName || "" }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Country</div>
              <div class="desp-item-content">{{ detail.supplier?.country || "" }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 发票 - 普通订单 -->
    <div class="desp-items-group">
      <div class="desp-items-group-title">Generic Invoice</div>
      <div class="desp-item">
        <div class="desp-item-self">
          <span class="mr40 to-link" @click="invoiceLink(detail?.invoice?.invoiceNumber)" v-if="detail?.invoice?.invoiceNumber">Invoice</span>
        </div>
      </div>
    </div>

    <!-- 上传的发票 -->
    <div class="desp-items-group" v-if="detail.status == 'COMPLETE' && detail.isInvoiceRevised">
      <div class="desp-items-group-title">Revised Invoice</div>
      <div class="desp-item">
        <div class="desp-item-self" v-if="detail.revisedInvoiceFile">
          <a class="to-link" :href="detail.revisedInvoiceFile.url" target="_target">
            {{ detail.revisedInvoiceFile.name }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Package from "@/components/ServiceGather/Package";
import DiyPackage from "@/components/ServiceGather/DiyPackage";
import QuotationSubtotal from "@/components/ServiceGather/QuotationSubtotal";
import QuotationVSingle from "@/components/ServiceGather/QuotationVSingle";
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [formatterMixin],
  components: {
    Package,
    DiyPackage,
    QuotationSubtotal,
    QuotationVSingle,
  },
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    // 发票跳转
    invoiceLink(invoiceNumber) {
      const newPage = `${process.env.VUE_APP_URL_INVOICE}/invoice?invoiceNo=${invoiceNumber}`;
      window.open(newPage, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.jump-icon {
  vertical-align: middle;
  font-size: 20px;
  margin-right: 6px;
  margin-top: -4px;
}

.to-link {
  cursor: pointer;
  color: #{$--color-primary};
}
</style>
